<!--p-dropdown [options]="options" *ngIf="options" [(ngModel)]="selectedValue" (onChange)="onOptionChange()"
    optionLabel="label" styleClass="option-to-close">
</p-dropdown-->
<irb-dropdown-filter
    #dropdownFilter
    [(value)]="selectedValue"
    (search)="populateDropdown($event)"
    (selection)="onOptionChange()"
    (keydown)="$event.stopPropagation()"
></irb-dropdown-filter>